import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementVersionInfo } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_VERSION_INFO } from "consts";

export const useGetPracticeManagementVersionInfo = (version: string | undefined) =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_VERSION_INFO, version],
    queryFn: () => getPracticeManagementVersionInfo(version!),
    enabled: !!version && version !== "draft",
  });
